import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import React, { useEffect } from "react";

//Cart Management
import { CartProvider } from "react-use-cart";

// Load Pages
import Faq from "./pages/faq";

// Results
import OverviewResults from "./pages/osculteo/results/OverviewResults";
import ImagesResults from "./pages/osculteo/results/ImagesResults";
import GoogleSuggestResults from "./pages/osculteo/results/GoogleSuggestResults";
import LinksResults from "./pages/osculteo/results/LinksResults";
import DocumentsResults from "./pages/osculteo/results/DocumentsResults";
import SocialInstagramResults from "./pages/osculteo/results/social/SocialInstagramResults";

// Diagnosis
import Diagnosis from "./pages/osculteo/Diagnosis";
import DiagnosisAnalysis from "./pages/osculteo/DiagnosisAnalysis";
import DiagnosisSelect from "./pages/osculteo/DiagnosisSelect";
// import DirectURL from "./pages/osculteo/DirectURL";

// Account
import {
  AccountContact,
  DataDeletion,
} from "./pages/account"; // Account pages

// Shopping Cart
import Dashboard from "./pages/osculteo/DashBoard";
import Cart from "./pages/shopping/Cart";
import CheckoutConfirmation from "./pages/shopping/CheckoutConfirmation";
import CheckoutInfo from "./pages/shopping/CheckoutInfo";
import CheckoutSuccess from "./pages/shopping/CheckoutSuccess";

//Contact
import Contact from "./pages/contact";

// Pages errors and maintenance
import { Error401, Error404, Maintenance } from "./pages/errors"; // Errors pages

import { DiagnosisProvider } from "./contexts/DiagnosisContext";
import MeNotMe from "./pages/osculteo/MeNotMe";
import Success from "./pages/offer/Succes";
import Cancel from "./pages/offer/Cancel";
import {
  QuotationExpand,
  Quotations,
} from "./pages/account/account-quotations";
import { Bills } from "./pages/account/account-bills";
import PrivateDataResults from "./pages/osculteo/results/PrivateDataresult";
import SinglePrivateDataResults from "./pages/osculteo/results/SinglePrivateDataResult";
import SocialYoutubeResults from "./pages/osculteo/results/social/youtube/SocialYoutubeResults";
import PseudoResults from "./pages/osculteo/results/PseudoResults";
import SinglePseudoResults from "./pages/osculteo/results/SinglePseudoResult";
import GoogleNewsSearchCard from "./pages/osculteo/results/news/GoogleNewsSearchCard";
import DarkWebSearchCard from "./pages/osculteo/results/darkweb/DarkWebSearchCard";
import { AuthenticatedProvider } from "./lib/AuthenticatedProvider";
import { Logout } from "./lib/Logout";
import Home from "./pages/home";
import { CguPage } from "./pages/legal/cgu";
import { PrivacyPage } from "./pages/legal/privacy";
import { CgvPage } from "./pages/legal/cgv";
import FacebookImagesResults from "./pages/osculteo/results/FacebookImagesResults"; import { CurrentLanguageContext } from "./contexts/currentLanguage";
import { CurrentLanguageManager } from "./lib/CurrentLanguageManager";
;

function App() {


  console.log("version : " + process.env.REACT_APP_VERSION);
  document.title = `${process.env.REACT_APP_SEO_TITLE}`;



  return (
    <>
      <AuthenticatedProvider scope={process.env.REACT_APP_OIDC_SCOPE as string} authority={process.env.REACT_APP_OIDC_AUTHORITY as string} client_id={process.env.REACT_APP_OIDC_CLIENT_ID as string} redirect_uri={process.env.REACT_APP_OIDC_REDIRECT_URI as string}>
        <CurrentLanguageManager>
          <CartProvider id="osculteo">
            <DiagnosisProvider>
              <BrowserRouter>
                <Routes>

                  <Route path="/" element={<ProtectedRoute component={Home} />} />

                  <Route path="/logout" element={<Logout />} />

                  <Route path="/contact" element={<Contact />} />

                  {/* --------------- Protected Route ---------------*/}

                  <Route
                    path="/dashboard"
                    element={<ProtectedRoute component={Dashboard} />}
                  />
                  <Route
                    path="/faq"
                    element={<ProtectedRoute component={Faq} />}
                  />

                  {/* diagnosis */}

                  <Route
                    path="/diagnosis"
                    element={<ProtectedRoute component={Diagnosis} />}
                  />
                  <Route
                    path="/diagnosis-analysis"
                    element={<ProtectedRoute component={DiagnosisAnalysis} />}
                  />
                  <Route
                    path="/diagnosis-select"
                    element={<ProtectedRoute component={DiagnosisSelect} />}
                  />
                  {/* <Route
                    path="/result/:diagUUID/direct-url"
                    element={<ProtectedRoute component={DirectURL} />}
                  /> */}

                  {/* diagnosis */}
                  <Route
                    path="/result/:diagUUID/overview"
                    element={<ProtectedRoute component={OverviewResults} />}
                  />
                  <Route
                    path="/result/:diagUUID/links"
                    element={<ProtectedRoute component={LinksResults} />}
                  />
                  <Route
                    path="/result/:diagUUID/images"
                    element={<ProtectedRoute component={ImagesResults} />}
                  />
                  <Route
                    path="/result/:diagUUID/facebook"
                    element={<ProtectedRoute component={FacebookImagesResults} />}
                  />
                  <Route
                    path="/result/:diagUUID/suggest"
                    element={
                      <ProtectedRoute component={GoogleSuggestResults} />
                    }
                  />
                  <Route
                    path="/result/:diagUUID/pseudo"
                    element={<ProtectedRoute component={PseudoResults} />}
                  />
                  {/* <Route
                {/* diagnosis */}
                  <Route
                    path="/result/:diagUUID/news"
                    element={<ProtectedRoute component={GoogleNewsSearchCard} />}
                  />
                  <Route
                    path="/result/:diagUUID/darkweb"
                    element={<ProtectedRoute component={DarkWebSearchCard} />}
                  />
                  {/* <Route
                  path="/result/:diagUUID/social"
                  element={<ProtectedRoute component={SocialResults} />}
                /> */}
                  <Route
                    path="/result/:diagUUID/documents"
                    element={<ProtectedRoute component={DocumentsResults} />}
                  />
                  <Route
                    path="/result/:diagUUID/menotme"
                    element={<ProtectedRoute component={MeNotMe} />}
                  />
                  <Route
                    path="/result/:diagUUID/social/instagram"
                    element={
                      <ProtectedRoute component={SocialInstagramResults} />
                    }
                  />
                  <Route
                    path="/result/:diagUUID/youtube"
                    element={
                      <ProtectedRoute component={SocialYoutubeResults} />
                    }
                  />

                  <Route
                    path="/result/:diagUUID/private-data"
                    element={<ProtectedRoute component={PrivateDataResults} />}
                  />
                  <Route
                    path="/result/:privateDataUuid/:diagUUID/single-private-data"
                    element={
                      <ProtectedRoute component={SinglePrivateDataResults} />
                    }
                  />

                  <Route
                    path="/result/:pseudoUuid/single-pseudo"
                    element={<ProtectedRoute component={SinglePseudoResults} />}
                  />

                  {/* account */}
                  <Route
                    path="/account"
                    element={<ProtectedRoute component={DataDeletion} />}
                  />
                  <Route
                    path="/account/contact"
                    element={<ProtectedRoute component={AccountContact} />}
                  />
                  <Route
                    path="/account/quotations"
                    element={<ProtectedRoute component={Quotations} />}
                  />
                  <Route
                    path="/account/quotations/quotation/:quotationUuid"
                    element={<ProtectedRoute component={QuotationExpand} />}
                  />

                  <Route
                    path="/account/bills"
                    element={<ProtectedRoute component={Bills} />}
                  />

                  {/* Order and Cart */}
                  <Route
                    path="/cart"
                    element={<ProtectedRoute component={Cart} />}
                  />
                  <Route
                    path="/order/checkout-success"
                    element={<ProtectedRoute component={CheckoutSuccess} />}
                  />
                  <Route
                    path="/order/checkout-info"
                    element={<ProtectedRoute component={CheckoutInfo} />}
                  />
                  <Route
                    path="/order/checkout-confirmation"
                    element={
                      <ProtectedRoute component={CheckoutConfirmation} />
                    }
                  />

                  <Route
                    path="/success"
                    element={<ProtectedRoute component={Success} />}
                  />
                  <Route
                    path="/cancel"
                    element={<ProtectedRoute component={Cancel} />}
                  />

                  {/* mentions */}
                  <Route path="/cgu" element={<CguPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/cgv" element={<CgvPage />} />

                  {/* errors */}
                  <Route path="/errors/401" element={<Error401 />} />
                  <Route path="/errors/404" element={<Error404 />} />
                  <Route path="/errors/404" element={<Error404 />} />
                  <Route path="/maintenance" element={<Maintenance />} />
                  <Route path="*" element={<Error404 />} />
                </Routes>
              </BrowserRouter>
            </DiagnosisProvider>
          </CartProvider>

        </CurrentLanguageManager>
      </AuthenticatedProvider>


    </>
  );
}

export default App;
